import { render, staticRenderFns } from "./TeacherLogout.vue?vue&type=template&id=38dcbccd"
import script from "./TeacherLogout.vue?vue&type=script&lang=js"
export * from "./TeacherLogout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports